import keysToConstants from 'js/lib/keysToConstants';

const PartnerRoles = keysToConstants(['PARTNER_ADMIN', 'INSTRUCTOR', 'DATA_COORDINATOR', 'TEACHING_STAFF']);

export const { PARTNER_ADMIN, INSTRUCTOR, DATA_COORDINATOR, TEACHING_STAFF } = PartnerRoles;

export default PartnerRoles;
